import { CommonApiResponse } from "../../../Controllers/Types/ApiResponse";
import { paymentCertificatesResponse } from "../../../Controllers/Types/Project/DefaultService/PaymentCertificateResponse";
import { baseURL } from "../../ApiConstant";


export const paymentCertificateGetDataApi = async (seriviceId : number): Promise<paymentCertificatesResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/payment-certificate/${seriviceId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
}

export const paymentCertificateCreateAPI = async (folder_id: number, certificate_no: string, total_amount: number, retention_amount: number, vat: number, certificate_amount: number, status: string, path: File): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();
        formData.append('folder_id', folder_id.toString());
        formData.append('certificate_no', certificate_no);
        formData.append('total_amount', total_amount.toString()); 
        formData.append('retention_amount', retention_amount.toString()); 
        formData.append('vat', vat.toString()); 
        formData.append('certificate_amount', certificate_amount.toString()); 
        formData.append('status', status); 
        if (path) {
            formData.append('path', path);
        }

        const response = await fetch(`${baseURL}/api/payment-certificate/create`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,

        });
        

        const data = await response.json();        

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const paymentCertificateUpdateAPI = async (certificateId: number, certificate_no: string, total_amount: number, retention_amount: number, vat: number, certificate_amount: number, status: string, path: File): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();
        formData.append('certificate_no', certificate_no);
        formData.append('total_amount', total_amount.toString()); 
        formData.append('retention_amount', retention_amount.toString()); 
        formData.append('vat', vat.toString()); 
        formData.append('certificate_amount', certificate_amount.toString()); 
        formData.append('status', status); 
        if (path) {
            formData.append('path', path);
        }

        const response = await fetch(`${baseURL}/api/payment-certificate/update/${certificateId}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,

        });
        

        const data = await response.json();        

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const paymentCertificateDeleteAPI = async (certificateId: number): Promise<CommonApiResponse> => {
    try {        
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/payment-certificate/delete/${certificateId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            }
        });
        
        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};